import { c as _c } from "react/compiler-runtime";
export const Plus = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" style={{
      width: "16px",
      height: "16px"
    }}><path d="M9 7h4a1 1 0 010 2H9v4a1 1 0 01-2 0V9H3a1 1 0 110-2h4V3a1 1 0 112 0v4z" fill="#000" fillRule="evenodd" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};